import React, { useEffect, useState, useRef } from 'react'

import Tone from  'tone'

import biats from './assets/audio/biats.mp3'


export const ATSAudioEngine = (props: {
  onLoad: () => {},
  onLevel: (n) => {}
}) => {

  const [engineLoaded, setEngineLoaded] = useState(false);

  const p = useRef(props)
  
  useEffect(() => {

    console.log("audio engine")


    const player = new Tone.Player(biats, (p) => {
      player.loopStart = 0.0
      player.loopEnd = 180.0 + 43.0
      player.playbackRate = 1
      player.loop = true
      player.volume.value = -5 //db


            player.start(Tone.now() , 0)
        
            setEngineLoaded(true)


      }).toMaster()


  }, [])

  useEffect(() => {
    if(engineLoaded){
      p.current.onLoad()
      // const clock = new Tone.Clock(function(time){
      //   p.current.onLevel(meter.current.getLevel() )
      // }, 30)

      // clock.start()
    }
  },[ engineLoaded, p])



  // useEffect(() => {

  // },[props, meter, delay])

  return (
      <div>
      </div>
  )
}

export default ATSAudioEngine;